import {useState, useEffect} from 'react';
import { Typography, Container, Checkbox, FormControlLabel, Box } from '@mui/material';
import {getListAPI as getCTlist} from '../../../compositiontemplate/CompositiontemplateAPI';

export default function ManageSaltActionImpl(){

    const [ctList, setCTList] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);

    useEffect(() => {
        getCTlist(setCTList, ()=>{});
    }, []);

    const handleCheck = (id) => {
        setSelectedIds(prev =>
            prev.includes(id)
                ? prev.filter(itemId => itemId !== id)
                : [...prev, id]
        );
    };

    return (
        <Container maxWidth="sm" sx={{ mt: 3 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>Manage Salt</Typography>
            <Box
                sx={{
                    maxHeight: '60vh', // Adjust as needed for your layout
                    overflowY: 'auto',
                    backgroundColor: 'white',
                    borderRadius: 2,
                    p: 2,
                    boxShadow: 1,
                }}
            >
                {ctList.map((item) => (
                    <FormControlLabel
                        key={item.id}
                        control={
                            <Checkbox
                                checked={selectedIds.includes(item.id)}
                                onChange={() => handleCheck(item.id)}
                            />
                        }
                        label={item.title}
                    />
                ))}
            </Box>
        </Container>
    );
}